import { Component, Input } from "@angular/core";

import {
  Community,
  CommunityMembership,
  MembershipListConfig,
} from "../../../../models";

import { MembershipListResult } from "../../../../interfaces";
import { MemberService } from "../../../../services";

@Component({
  selector: "membership-list",
  templateUrl: "./membership-list.component.html",
  styleUrls: [
    "./membership-list.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MembershipListComponent {
  constructor(private memberService: MemberService) {}

  private query: MembershipListConfig;
  public results: CommunityMembership[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;
  public totalCount: number;

  @Input() community: Community;
  @Input() limit: number;
  @Input()
  set config(config: MembershipListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public fetchMembers() {
    this.memberService
      .findManyMembers(this.community.name, this.query)
      .subscribe((data: MembershipListResult) => {
        this.loading = false;
        this.results = data.members;
        this.totalCount = data.memberCount.total;
        this.totalPages = data.pages.total;
      });
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.limit = this.limit;
      this.query.offset = this.limit * (this.currentPage - 1);
    }

    this.fetchMembers();
    window.scroll(0, 0);
  }
}
